import { useState, useEffect } from 'react';
import { message } from 'antd';
import {
  vehicleFeatureService,
  VehicleFeature,
  CreateVehicleFeatureRequest,
} from '../../api/services/vehicleFeatureService';

export const useVehicleFeatures = () => {
  const [features, setFeatures] = useState<VehicleFeature[]>([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingFeature, setEditingFeature] = useState<VehicleFeature | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const fetchFeatures = async () => {
    setLoading(true);
    try {
      const result = await vehicleFeatureService.getFeatures();
      setFeatures(Array.isArray(result) ? result : []);
    } catch {
      message.error('Failed to load vehicle features');
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (values: CreateVehicleFeatureRequest) => {
    setSubmitting(true);
    try {
      await vehicleFeatureService.createFeature(values);
      message.success('Vehicle feature created');
      setModalVisible(false);
      fetchFeatures();
    } catch {
      message.error('Failed to create vehicle feature');
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async (id: number) => {
    try {
      await vehicleFeatureService.deleteFeature(id);
      message.success('Vehicle feature deleted');
      fetchFeatures();
    } catch {
      message.error('Failed to delete vehicle feature');
    }
  };

  const openCreateModal = () => {
    setEditingFeature(null);
    setModalVisible(true);
  };

  const openEditModal = (feature: VehicleFeature) => {
    setEditingFeature(feature);
    setModalVisible(true);
  };

  useEffect(() => {
    fetchFeatures();
  }, []);

  return {
    features,
    loading,
    modalVisible,
    editingFeature,
    submitting,
    setModalVisible,
    handleCreate,
    handleDelete,
    openCreateModal,
    openEditModal,
    refetch: fetchFeatures,
  };
};
